import React, { useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Link,
  Stack,
} from '@mui/material';
import { useAppBar } from '../providers/AppBarProvider';
import logotype from '../assets/logotype_fin_1.webp';
import { useTranslation } from 'react-i18next';

// Constants
const DOCTOR_VET_BASE_URL = import.meta.env.VITE_WEB_URL;

function MainAbout() {
  const { updateTitle, toggleFab } = useAppBar();
  const { t } = useTranslation();

  useEffect(() => {
    toggleFab(false);
    updateTitle('', t('main.about'));
  }, []);

  const handleTermsClick = () => {
    window.open(DOCTOR_VET_BASE_URL + 'terms-and-conditions.html', '_blank');
  };

  const handlePrivacyClick = () => {
    window.open(DOCTOR_VET_BASE_URL + 'privacy-policy.html', '_blank');
  };

  const handleWebClick = () => {
    window.open(DOCTOR_VET_BASE_URL, '_blank');
  };

  const handleEmailClick = () => {
    window.open('mailto:doctorvet@xionce.com', '_blank');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5492617065917', '_blank');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 4,
          px: 2,
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src={logotype}
          alt="Doctor Vet Logo"
          sx={{
            width: 130,
            height: 130,
            mb: 2,
          }}
        />

        {/* Title */}
        <Typography
          variant="h4"
          component="h1"
          align="center"
          sx={{
            mb: 1,
            fontWeight: 'bold',
          }}
        >
          {t('main.aboutTitle')}
        </Typography>

        {/* Quote */}
        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 4,
            px: 4,
            fontStyle: 'italic',
            color: 'text.secondary',
          }}
        >
          {t('main.aboutQuote')}
        </Typography>

        {/* Terms and Conditions */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {t('main.aboutTermsIntro')}
          </Typography>
          <Link
            component="button"
            variant="body1"
            onClick={handleTermsClick}
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {t('main.termsAndConditions')}
          </Link>
        </Box>

        {/* Privacy Policy */}
        <Link
          component="button"
          variant="body1"
          onClick={handlePrivacyClick}
          sx={{
            textDecoration: 'none',
            color: 'primary.main',
            cursor: 'pointer',
            mb: 4,
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {t('login.privacyPolicy')}
        </Link>

        {/* Contact Information */}
        <Stack spacing={2} sx={{ width: '100%', textAlign: 'center' }}>
          <Link
            component="button"
            variant="body1"
            onClick={handleWebClick}
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {DOCTOR_VET_BASE_URL}
          </Link>

          <Link
            component="button"
            variant="body1"
            onClick={handleEmailClick}
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Email: doctorvet@xionce.com
          </Link>

          <Link
            component="button"
            variant="body1"
            onClick={handleWhatsAppClick}
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            WhatsApp: +5492617065917
          </Link>
        </Stack>
      </Box>
    </Container>
  );
}

export default MainAbout; 